import { useEffect } from 'react'


const AppRedirect = () => {
  const IOS_URL = 'https://apps.apple.com/in/app/free-the-sea/id6754189942'
  const ANDROID_URL =
    'https://play.google.com/store/apps/details?id=com.asm.freethesea&pcampaignid=web_share'

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS =
      /iPad|iPhone|iPod/i.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isAndroid = /Android/i.test(ua);

    if (isIOS) {
      window.location.replace(IOS_URL);
    } else if (isAndroid) {
      window.location.replace(ANDROID_URL);
    }
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontFamily: 'sans-serif',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          textAlign: 'center',
          padding: '32px',
        }}
      >
        {/* Loader */}
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          style={{
            marginTop: '8px',
            animation: 'spin 1s linear infinite',
          }}
        >
          <circle
            cx="16"
            cy="16"
            r="13"
            fill="none"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="3"
          />

          <circle
            cx="16"
            cy="16"
            r="13"
            fill="none"
            stroke="#FFE500"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="55 100"
          />
        </svg>

        <style>
          {`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}
        </style>
      </div>
    </div>
  )
}

export { AppRedirect }
